var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000713",
    fillRule: "evenodd",
    d: "M8.4 2.667a2.333 2.333 0 1 0 0 4.666 2.333 2.333 0 0 0 0-4.666M4.733 5a3.667 3.667 0 1 1 7.333 0 3.667 3.667 0 0 1-7.333 0M8.4 11.333c-2.128 0-4.071.926-5.515 2.458a.667.667 0 1 1-.97-.915C3.585 11.104 5.87 10 8.4 10s4.814 1.104 6.485 2.876a.667.667 0 1 1-.97.915c-1.444-1.532-3.388-2.458-5.515-2.458",
    clipRule: "evenodd"
  })));
};
export default SvgUser;